/**
 * Main application entry point
 */

import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@/config/moment.config'; // Configure dayjs locale globally (legacy filename kept)
import App from './App';
import { AdminWSProvider } from '@/providers/AdminWSProvider';
import './index.css';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <AdminWSProvider>
      <App />
    </AdminWSProvider>
  </QueryClientProvider>
);

// Service Worker handling:
// - PROD: register generated /sw.js
// - DEV: unregister any stale SWs to prevent cache/script mismatches
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      if (import.meta.env.DEV) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((reg) => reg.unregister()));
        return;
      }

      // El /sw.js que genera VitePWA (workbox + importScripts) es un SW
      // CLÁSICO. Registrarlo con `type: 'module'` rompe la instalación
      // porque los module service workers no soportan importScripts().
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registered successfully:', registration);
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  });
}
